export const events = {
  PagesViewed: 'pages_viewed',
  PagesDocumentsUploadStarted: 'pages_documents_upload_started',
  PagesDocumentsUploaded: 'pages_documents_uploaded',
  PagesDocumentsReviewed: 'pages_documents_reviewed',
  PagesDocumentsPublished: 'pages_documents_published',
  PagesDocumentsPublishConfirmed: 'pages_documents_publish_confirmed',
  PagesFolderViewed: 'pages_folder_viewed',
  PagesCreateNewPage: 'pages_create_new_page',
  PagesPublishNewPage: 'pages_publish_new_page',
  PagesPublishNewPageConfirmation: 'pages_publish_new_page_confirmation',
  PagesEditPage: 'pages_edit_page',
}
